/* ----------------------------------------------------------------------------
   KARMA — BUNDLE (remplacement de l'app Kaching Bundles)

   Deux petits éléments, et rien d'autre — le JS est limité à ce que le CSS ne
   peut réellement pas faire :

   1. <karma-countdown>  : compte à rebours jusqu'à minuit (heure locale),
                           recommence chaque jour.
   2. <karma-bundle-button> : ajoute au panier les produits de l'offre choisie
                           (+ l'option cochée) en reproduisant EXACTEMENT le
                           flux du thème Impact (mêmes appels, mêmes événements
                           cart:prepare-bundled-sections / variant:add /
                           cart:change) pour que le tiroir de panier natif
                           s'ouvre et se rafraîchisse tout seul.
---------------------------------------------------------------------------- */

if (!window.customElements.get("karma-countdown")) {
  class KarmaCountdown extends HTMLElement {
    connectedCallback() {
      this._target = this.querySelector("[data-countdown]") || this;
      this._tick();
      this._interval = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _tick() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      let s = Math.max(0, Math.floor((midnight - now) / 1000));
      const h = String(Math.floor(s / 3600)).padStart(2, "0");
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
      const sec = String(s % 60).padStart(2, "0");
      this._target.textContent = `${h}:${m}:${sec}`;
    }
  }
  window.customElements.define("karma-countdown", KarmaCountdown);
}

/* ----------------------------------------------------------------------------
   ABONNEMENT (2026-08-18)

   La case « abonnement » fait deux choses, et rien de plus :

   1. Elle bascule les prix affichés vers le prix abonné. Ces prix ne sont pas
      calculés ici : ils viennent de Shopify (attribut data-kb-abo, rempli en
      Liquid depuis variant.selling_plan_allocations).
   2. Elle fait ajouter `selling_plan` à chaque ligne envoyée au panier — c'est
      ce qui crée le contrat d'abonnement, donc la cliente dans Kaching
      Subscriptions. Relevé sur le site en ligne le 2026-08-18, Kaching envoie
      exactement la même chose.

   Ce bloc est placé AVANT le bouton : les prix sont déjà à jour quand le bouton
   recopie le total de l'offre choisie.
---------------------------------------------------------------------------- */

if (!window.karmaBundleAbonnement) {
  window.karmaBundleAbonnement = true;

  const karmaCaseAbo = () => document.querySelector("input[data-karma-subscription]");

  const karmaMajPrixAbonnes = () => {
    const abo = karmaCaseAbo();
    const actif = Boolean(abo && abo.checked);

    document.querySelectorAll("[data-kb-abo]").forEach((element) => {
      if (element.dataset.kbNormal === undefined) {
        element.dataset.kbNormal = element.textContent.trim();
      }
      element.textContent = actif ? element.dataset.kbAbo : element.dataset.kbNormal;
    });
  };

  /* En phase de capture : les prix sont mis à jour avant que le bouton ne les lise */
  document.addEventListener(
    "change",
    (event) => {
      if (event.target && event.target.matches && event.target.matches("input[data-karma-subscription]")) {
        karmaMajPrixAbonnes();
      }
    },
    true
  );

  window.karmaMajPrixAbonnes = karmaMajPrixAbonnes;
  karmaMajPrixAbonnes();
}

if (!window.customElements.get("karma-bundle-button")) {
  class KarmaBundleButton extends HTMLElement {
    connectedCallback() {
      this._button = this.querySelector("button");
      this._onClick = (event) => this._addToCart(event);
      this._button?.addEventListener("click", this._onClick);

      // Le prix de l'offre choisie s'affiche dans le bouton et suit la sélection
      // (demande de Gita, 2026-08-17). Les montants sont recopiés depuis la carte :
      // ils restent donc calculés par Shopify, dans la devise du visiteur.
      this._total = this.querySelector("[data-kb-total]");
      if (this._total) {
        this._onChange = () => this._majPrix();
        document.addEventListener("change", this._onChange);
        this._majPrix();
      }
    }

    disconnectedCallback() {
      this._button?.removeEventListener("click", this._onClick);
      if (this._onChange) document.removeEventListener("change", this._onChange);
    }

    _majPrix() {
      if (!this._total) return;

      const scope = this.getAttribute("scope");
      const radios = document.querySelectorAll(`input[name="karma-offer-${scope}"]`);
      const choisi = [...radios].find((r) => r.checked) || radios[0];
      const carte = choisi?.closest("[data-karma-offer]");
      if (!carte) {
        this._total.hidden = true;
        return;
      }

      const prix = carte.querySelector(".karma-bundle__pricing .karma-bundle__price");
      const barre = carte.querySelector(".karma-bundle__pricing .karma-bundle__compare");

      // L'option cochée (shampoing) s'ajoute au total affiché
      let total = this._enCentimes(prix?.textContent);
      let compare = this._enCentimes(barre?.textContent);
      const upsell = carte.querySelector("input[data-upsell-item]");
      if (upsell?.checked) {
        const ligne = upsell.closest(".karma-bundle__upsell");
        const pu = this._enCentimes(ligne?.querySelector(".karma-bundle__price")?.textContent);
        const cu = this._enCentimes(ligne?.querySelector(".karma-bundle__compare")?.textContent);
        if (total !== null && pu !== null) total += pu;
        if (compare !== null && cu !== null) compare += cu;
      }

      const cible = this._total.querySelector("[data-kb-total-price]");
      const cibleBarre = this._total.querySelector("[data-kb-total-compare]");
      if (cible) cible.textContent = total === null ? (prix?.textContent || "") : this._format(total, prix?.textContent);
      if (cibleBarre) cibleBarre.textContent = compare === null ? "" : this._format(compare, barre?.textContent || prix?.textContent);
      this._total.hidden = false;
    }

    // Lit « 98,00 € » ou « 98.00 CHF » → 9800 (centimes), quel que soit le format
    _enCentimes(texte) {
      if (!texte) return null;
      const nombre = texte.replace(/[^0-9.,]/g, "").replace(/\s/g, "");
      if (!nombre) return null;
      const normalise = nombre.includes(",") && nombre.lastIndexOf(",") > nombre.lastIndexOf(".")
        ? nombre.replace(/\./g, "").replace(",", ".")
        : nombre.replace(/,/g, "");
      const valeur = parseFloat(normalise);
      return Number.isFinite(valeur) ? Math.round(valeur * 100) : null;
    }

    // Réutilise le format exact du prix source (symbole, séparateurs, position)
    _format(centimes, modele) {
      const montant = (centimes / 100).toFixed(2);
      if (!modele) return montant;
      const chiffres = modele.match(/[0-9][0-9.,\s ]*[0-9]|[0-9]/);
      if (!chiffres) return montant;
      const separateur = chiffres[0].includes(",") ? "," : ".";
      return modele.replace(chiffres[0], montant.replace(".", separateur));
    }

    async _addToCart(event) {
      event.preventDefault();

      if (this._submitting) {
        return;
      }

      const scope = this.getAttribute("scope");
      const radios = document.querySelectorAll(`input[name="karma-offer-${scope}"]`);
      const checked = [...radios].find((radio) => radio.checked) || radios[0];

      if (!checked) {
        return;
      }

      let items = [];

      try {
        items = JSON.parse(checked.dataset.items || "[]");
      } catch (error) {
        items = [];
      }

      const offerRoot = checked.closest("[data-karma-offer]");
      const upsell = offerRoot?.querySelector("input[data-upsell-item]");

      if (upsell?.checked) {
        try {
          items.push(JSON.parse(upsell.dataset.upsellItem));
        } catch (error) {
          /* option illisible : on n'ajoute que l'offre */
        }
      }

      if (items.length === 0) {
        return;
      }

      /* Abonnement : chaque ligne éligible part avec son `selling_plan`.
         C'est ce que Shopify attend (doc Cart AJAX API) et ce que Kaching envoie.
         Une ligne sans « plan » — produit non abonnable — part au tarif normal. */
      const caseAbo = document.querySelector("input[data-karma-subscription]");
      const avecAbonnement = Boolean(caseAbo && caseAbo.checked);

      /* Le CADEAU part sur sa propre ligne, SANS abonnement (2026-08-19).

         Règle de Gita : le cadeau est offert à la première commande, mais ne doit PAS
         revenir à chaque renouvellement. Or côté remise, Shopify n'offre aucun moyen de
         limiter un « X acheté = Y offert » à la première commande (le champ
         recurringCycleLimit existe pour les remises en %, pas pour les X/Y).
         La seule prise est ici : une ligne sans `selling_plan` n'entre pas dans le
         contrat d'abonnement, donc elle ne peut pas se renouveler.

         Sans abonnement, on ne découpe rien : une seule ligne, comme avant. */
      const decoupees = [];

      items.forEach((ligne) => {
        const abonnable = avecAbonnement && ligne.plan;
        const offerts = Number(ligne.offerts) || 0;
        const payes = ligne.quantity - offerts;

        if (abonnable && offerts > 0 && payes > 0) {
          decoupees.push({ id: ligne.id, quantity: payes, selling_plan: ligne.plan });
          decoupees.push({ id: ligne.id, quantity: offerts });
          return;
        }

        const item = { id: ligne.id, quantity: ligne.quantity };
        if (abonnable) {
          item.selling_plan = ligne.plan;
        }
        decoupees.push(item);
      });

      items = decoupees;

      this._submitting = true;
      this._button.setAttribute("aria-busy", "true");

      /* Même contrat que le product-form d'Impact (assets/theme.js) */
      const sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(","),
          sections_url: `${Shopify.routes.root}variants/${items[0].id}`
        })
      });

      const responseJson = await response.json();

      this._button.removeAttribute("aria-busy");
      this._submitting = false;

      if (response.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          window.location.href = `${Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: "variant:add", cart: cartContent }
          })
        );
      } else {
        this.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: responseJson["description"] }
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
  }
  window.customElements.define("karma-bundle-button", KarmaBundleButton);
}
